import React, { useContext } from "react";
import PropTypes from "prop-types";
import FaqNav from "app/pages/Faq/FaqNav/FaqNav";
import "./FaqAsideNav.scss";
import RelativeLink from "app/pages/.shared/RelativeLink";
import { FormattedMessage } from "react-intl";
import IconHome from "app/pages/.shared/static/icons/IconHome";
import LogoBrandContainer from "app/pages/.shared/LogoBrand/LogoBrandContainer";
import { BRANDS } from "app/constants";
import IconCrossDark from "app/pages/.shared/static/icons/IconCrossDark";
import AppGlobalsContext from "app/AppGlobalsContext";

const FaqAsideNav = ({ faqCategories, hideSidePanel }) => {
	const { brand } = useContext(AppGlobalsContext);

	return (
		<div className="faq-aside-nav" onClick={hideSidePanel}>
			<div className="faq-aside-nav__header">
				<div className="faq-aside-nav__logo">
					<RelativeLink to={{ pathname: "/faq" }} data-cy="header-back-link">
						<LogoBrandContainer isWhite={brand === BRANDS.EK || brand === BRANDS.HP} />
					</RelativeLink>
				</div>
				<div className="faq-aside-nav__close">
					<IconCrossDark onClick={hideSidePanel} />
				</div>
			</div>
			<div className="faq-aside-nav__body">
				<div className="faq-aside-nav__home">
					<RelativeLink
						to={{
							pathname: `/faq`,
						}}
					>
						<IconHome height={20} width={20} style={{ marginRight: "10px" }} />
						<FormattedMessage id="faq.breadcrumb.home" />
					</RelativeLink>
				</div>
				<FaqNav faqCategories={faqCategories} />
			</div>
		</div>
	);
};

FaqAsideNav.propTypes = {
	faqCategories: PropTypes.array,
	hideSidePanel: PropTypes.func,
};

export default FaqAsideNav;
